import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';

import { LogoComponent } from './logo.component';
import { LogoImgComponent } from './logo-img/logo-img.component';

/**
 * Angular module providing logo components for application branding.
 *
 * @remarks
 * This module exports {@link LogoComponent} and {@link LogoImgComponent} along with their
 * required dependencies. Import this module to render the company logo in feature modules.
 *
 * - {@link LogoComponent} renders the logo as a styled element using CSS background images.
 * - {@link LogoImgComponent} renders the logo as an `<img>` element with configurable sources
 *   and sizes. Override defaults application-wide via {@link BB_LOGO_IMG_GLOBAL_CONFIGURATION}.
 *
 * {@link LogoImgComponent} is standalone and may also be imported directly where module
 * imports are not required.
 *
 * @example
 *
 * ```typescript
 * import { LogoModule } from '@backbase/ui-ang/logo';
 *
 * @NgModule({
 *   imports: [LogoModule],
 * })
 * export class MyFeatureModule {}
 * ```
 */
@NgModule({
  imports: [NgClass, LogoImgComponent],
  declarations: [LogoComponent],
  exports: [LogoComponent, LogoImgComponent],
})
export class LogoModule {}
